import { Link } from 'react-router-dom';
import { comics, featuredComicIds } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = featuredComicIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">编辑团队精心挑选的高品质韩漫，每一部都不容错过</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {featured.map((comic) => comic && (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-background-50 text-xs font-label">{comic.author}</span>
                </div>
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-label ${
                    comic.status === '连载中' ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-foreground-600 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-label font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-xs text-foreground-500">{comic.rating}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/fantasy-adventure"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-label transition-colors cursor-pointer"
          >
            查看全部推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}